/**
 * 
 * @param {Array} data 数组, 可以是数字数组, 也可以是对象数组
 * @param {key: string | symbol} options 如果数据是对象数组需要提供键名
 */
export const max = (data, options = {}) => {
  let max = "";
  const { key = "" } = options;
  for (let i = 0, len = data.length; i < len; i++) {
    const item = data[i];
    if (i === 0) {
      max = item;
      continue;
    }
    if (typeof item === "number" || !isNaN(Number(item))) {
      if (item > max) {
        max = item;
      }
      continue;
    }
    if (item[key] > max[key]) {
      max = item;
    }
  }
  return max;
}